"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BankAccountNumberValidator_1 = require("./BankAccountNumberValidator");
var BankgiroValidator_1 = require("./BankgiroValidator");
var ClearingNumberValidator_1 = require("./ClearingNumberValidator");
var DateValidator_1 = require("./DateValidator");
var DecimalValidator_1 = require("./DecimalValidator");
var BlacklistValidator_1 = require("./BlacklistValidator");
var EmailValidator_1 = require("./EmailValidator");
var IntegerValidator_1 = require("./IntegerValidator");
var GreaterThanValidator_1 = require("./GreaterThanValidator");
var LessThanValidator_1 = require("./LessThanValidator");
var MatchesValidator_1 = require("./MatchesValidator");
var MaxLengthValidator_1 = require("./MaxLengthValidator");
var MaxValueValidator_1 = require("./MaxValueValidator");
var MinDateValidator_1 = require("./MinDateValidator");
var MaxDateValidator_1 = require("./MaxDateValidator");
var MinLengthValidator_1 = require("./MinLengthValidator");
var MinValueValidator_1 = require("./MinValueValidator");
var NumberValidator_1 = require("./NumberValidator");
var OrganisationsnummerValidator_1 = require("./OrganisationsnummerValidator");
var PercentValidator_1 = require("./PercentValidator");
var PersonnummerValidator_1 = require("./PersonnummerValidator");
var PhoneNumberValidator_1 = require("./PhoneNumberValidator");
var PlusgiroValidator_1 = require("./PlusgiroValidator");
var PostalCodeValidator_1 = require("./PostalCodeValidator");
var RequiredValidator_1 = require("./RequiredValidator");
var WhitelistValidator_1 = require("./WhitelistValidator");
/**
 * Supported validators.
 */
exports.validators = {
    bankAccountNumber: BankAccountNumberValidator_1.bankAccountNumberValidator,
    bankgiro: BankgiroValidator_1.bankgiroValidator,
    clearingNumber: ClearingNumberValidator_1.clearingNumberValidator,
    dateFormat: DateValidator_1.dateFormatValidator,
    date: DateValidator_1.dateValidator,
    decimal: DecimalValidator_1.decimalValidator,
    blacklist: BlacklistValidator_1.blacklistValidator,
    email: EmailValidator_1.emailValidator,
    integer: IntegerValidator_1.integerValidator,
    greaterThan: GreaterThanValidator_1.greaterThanValidator,
    lessThan: LessThanValidator_1.lessThanValidator,
    minLength: MinLengthValidator_1.minLengthValidator,
    matches: MatchesValidator_1.matchesValidator,
    maxLength: MaxLengthValidator_1.maxLengthValidator,
    minValue: MinValueValidator_1.minValueValidator,
    maxValue: MaxValueValidator_1.maxValueValidator,
    minDate: MinDateValidator_1.minDateValidator,
    maxDate: MaxDateValidator_1.maxDateValidator,
    number: NumberValidator_1.numberValidator,
    organisationsnummer: OrganisationsnummerValidator_1.organisationsnummerValidator,
    percent: PercentValidator_1.percentValidator,
    personnummer: PersonnummerValidator_1.personnummerValidator,
    phoneNumber: PhoneNumberValidator_1.phoneNumberValidator,
    plusgiro: PlusgiroValidator_1.plusgiroValidator,
    postalCode: PostalCodeValidator_1.postalCodeValidator,
    required: RequiredValidator_1.requiredValidator,
    whitelist: WhitelistValidator_1.whitelistValidator,
};
//# sourceMappingURL=index.js.map